import { render, staticRenderFns } from "./StaticFields.vue?vue&type=template&id=5507ca92&"
import script from "./StaticFields.vue?vue&type=script&lang=ts&"
export * from "./StaticFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports